var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartLoaded)?_c('LineChart',{attrs:{"chartdata":_vm.chartData,"options":_vm.chartOptions,"width":null,"height":null}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }